'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CURRENCY;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CURRENCY_TYPES = exports.CURRENCY_TYPES = {
    EUR: 'EUR',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    USD: 'USD'
};

var CURRENCY = exports.CURRENCY = (_CURRENCY = {
    default: {
        symbol: '$'
    }
}, _defineProperty(_CURRENCY, CURRENCY_TYPES.EUR, {
    code: CURRENCY_TYPES.EUR,
    symbol: '€'
}), _defineProperty(_CURRENCY, CURRENCY_TYPES.JPY, {
    code: CURRENCY_TYPES.JPY,
    symbol: '¥'
}), _defineProperty(_CURRENCY, CURRENCY_TYPES.GBP, {
    code: CURRENCY_TYPES.GBP,
    symbol: '£'
}), _CURRENCY);


//////////////////
// WEBPACK FOOTER
// ./src/common/payment/currencyConstants.js
// module id = 2285
// module chunks = 0